import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { DebugPanelComponent } from './debug-panel.component';
import { debugStateReducer } from './state';

/**
 * The debug log without any routing, for hosts that render it inside their own page layout.
 * DebugModule imports this and adds the page chrome plus the standalone /debug route.
 */
@NgModule({
    declarations: [DebugPanelComponent],
    exports: [DebugPanelComponent],
    imports: [CommonModule, IonicModule, TranslateModule, StoreModule.forFeature('debug', debugStateReducer)]
})
export class DebugPanelModule {}
